import { ReactElement } from 'react';

import { AutocompleteOption } from '@breathelife/ui-components';
import {
  ApplicationMode,
  FieldBlueprintBase,
  QuestionnaireBlueprintCopyableOption,
  QuestionnaireBlueprintCopyableOptions,
} from '@zinnia/form-engine-sdk';

import { dataLabelSelectionToDataLabel } from '../../../../../../../Helpers/questionnaireEditor/selectOptions';
import { AdvancedBlueprintOptions } from '../../../Components/AdvancedBlueprintOptions';
import { BaseFieldSetters } from '../../useDataByField/useBaseFieldData';

type AdvancedBlueprintOptionsForFieldProps = {
  data: FieldBlueprintBase;
  setters: BaseFieldSetters;
  dataLabelOptions: AutocompleteOption[];
};

export function AdvancedBlueprintOptionsForField({
  data,
  setters,
  dataLabelOptions,
}: AdvancedBlueprintOptionsForFieldProps): ReactElement {
  return (
    <AdvancedBlueprintOptions
      tag='field'
      platform={{
        selected: data?.platforms || [],
        onChange: (platforms) => {
          setters.setPlatforms(platforms);
        },
      }}
      renderOn={{
        selected: data?.renderOn || [],
        onChange: (renderOn) => {
          setters.setRenderOn(renderOn);
        },
      }}
      pdfDocument={{
        selected: data?.pdfDocuments || [],
        onChange: (pdfDocuments) => {
          setters.setPdfDocuments(pdfDocuments);
        },
      }}
      dataLabel={{
        selected: data?.dataLabel,
        options: dataLabelOptions,
        onChange: (value) => {
          if (value !== null) {
            setters.setDataLabel(dataLabelSelectionToDataLabel(value));
          }
        },
      }}
      copyable={{
        selected: data?.copyable || QuestionnaireBlueprintCopyableOptions.none,
        onChange: (value) => {
          setters.setCopyable(value as QuestionnaireBlueprintCopyableOption);
        },
      }}
      disabled={false}
      applicationModes={{
        selected: data?.applicationModes || [],
        onChange: (updatedMode: ApplicationMode[]) => {
          setters.setApplicationModes(updatedMode);
        },
      }}
    />
  );
}
